/**
 * Service class for managing cookie consent.
 */
export default function cookieConsentService() {
  /**
   * Initializes the cookie consent service.
   */
  function onInit() {
    document.querySelector('.cookie-consent-close').addEventListener('click', closeCookieConsent);
    handleCookieConsent();
  }

  /**
   * Checks if cookie consent was previously given.
   */
  function shouldDisplayCookieConsent() {
    return !localStorage.getItem('cookie-consent');
  }

  /**
   * Handles the cookie consent banner display logic.
   */
  function handleCookieConsent() {
    if (!shouldDisplayCookieConsent()) {
      return;
    }

    document.querySelector('body').classList.add('cookie-consent-active');
  }

  /**
   * Closes the cookie consent banner and sets a flag in localStorage to prevent it from showing again.
   */
  function closeCookieConsent() {
    localStorage.setItem('cookie-consent', 'true');
    document.querySelector('body').classList.remove('cookie-consent-active');
  }

  onInit();
}
